/* LinknLink first-party attribution capture: draft-only implementation. */
(function () {
  'use strict';

  var STORAGE_KEY = 'll_attr_state_v1';
  var COOKIE_KEY = 'll_attr_state_v1';
  var PARAMS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'll_campaign_id', 'll_asset_group_id', 'll_network', 'll_device',
    'gclid', 'gbraid', 'wbraid'
  ];
  var MAX = 500;

  function clean(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().slice(0, MAX);
  }

  function readState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw) || {};
    } catch (e) {}
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_KEY + '=([^;]*)'));
      if (match) return JSON.parse(decodeURIComponent(match[1])) || {};
    } catch (e) {}
    return {};
  }

  function writeState(state) {
    var serialized;
    try { serialized = JSON.stringify(state); } catch (e) { return; }
    try { window.localStorage.setItem(STORAGE_KEY, serialized); } catch (e) {}
    try {
      document.cookie = COOKIE_KEY + '=' + encodeURIComponent(serialized) + '; path=/; max-age=63072000; SameSite=Lax';
    } catch (e) {}
  }

  function currentTouch() {
    var params = new URLSearchParams(window.location.search || '');
    var touch = {};
    PARAMS.forEach(function (name) { touch[name] = clean(params.get(name)); });
    touch.landing = clean(window.location.href);
    touch.referrer = clean(document.referrer);
    touch.timestamp = new Date().toISOString();
    return touch;
  }

  function isValidMarketingTouch(touch) {
    return Boolean(
      touch.utm_source || touch.utm_medium || touch.utm_campaign ||
      touch.ll_campaign_id || touch.gclid || touch.gbraid || touch.wbraid
    );
  }

  function firstTouch(state, touch) {
    var result = {};
    ['source', 'medium', 'campaign', 'campaign_id', 'asset_group_id', 'gclid', 'gbraid', 'wbraid', 'landing', 'referrer', 'timestamp'].forEach(function (field) {
      var param = field === 'source' ? 'utm_source' :
        field === 'medium' ? 'utm_medium' :
        field === 'campaign' ? 'utm_campaign' :
        field === 'campaign_id' ? 'll_campaign_id' :
        field === 'asset_group_id' ? 'll_asset_group_id' : field;
      result['ll_attr_first_' + field] = clean(touch[param]);
    });
    return result;
  }

  function lastTouch(touch) {
    var result = {};
    ['source', 'medium', 'campaign', 'campaign_id', 'asset_group_id', 'gclid', 'gbraid', 'wbraid', 'landing', 'referrer', 'timestamp'].forEach(function (field) {
      var param = field === 'source' ? 'utm_source' :
        field === 'medium' ? 'utm_medium' :
        field === 'campaign' ? 'utm_campaign' :
        field === 'campaign_id' ? 'll_campaign_id' :
        field === 'asset_group_id' ? 'll_asset_group_id' : field;
      result['ll_attr_last_' + field] = clean(touch[param]);
    });
    return result;
  }

  function syncCart(state) {
    var attributes = {};
    Object.keys(state).forEach(function (key) {
      if (key.indexOf('ll_attr_') === 0 && clean(state[key])) attributes[key] = clean(state[key]);
    });
    if (!Object.keys(attributes).length || !window.fetch) return;
    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  var touch = currentTouch();
  var state = readState();
  if (isValidMarketingTouch(touch)) {
    if (!state.ll_attr_first_timestamp) Object.assign(state, firstTouch(state, touch));
    Object.assign(state, lastTouch(touch));
    writeState(state);
  }
  syncCart(state);
}());
